(function() {
    angular.module('ngmvac').controller('paymentController', PaymentController);
    PaymentController.$inject = ['$scope', '$window', '$filter', '$timeout', 'PaymentFactory', 'Cart', 'timeService', 'HotelFactory'];

    function PaymentController($scope, $window, $filter, $timeout, PaymentFactory, Cart, timeService, HotelFactory) {
        var vm = this;
        vm.couponAdded = false;
        vm.coupon = {};
        vm.counter = 0;
        vm.timeExpired = false;
        vm.hotelData = {};
        vm.completePayment = true;
        vm.pathImages = 'https://photos.hotelbeds.com/giata/bigger/';
        $scope.currentPercent;
        vm.metodopago      = '';
        vm.monto           = '';
        vm.moneda          = '';
        vm.summary         = '';
        vm.urlwebpay       = '';
        vm.total           = 0;
        vm.cambiartarjeta  = true;
        vm.formapago       = '';
        vm.cmeses          = 0;
        
        vm.totalpagar      = 0;
        vm.bancoselected   = '';
        vm.tarjetas        = "";
        vm.tarjetaselect   = "";
        vm.tresmeses       = false;
        vm.seismeses       = false;
        vm.nuevemeses      = false;
        vm.docemeses       = false;
        vm.cart            = {};
        vm.webpay          = false;

        vm.showformpagos   = false;
        vm.showFormAmex    = false;

        $('#form-datos-pago-res').show();
        $('#diviframe').hide();
        $('#diviframevisa').hide();
        $('#form-amex').hide();
        $('#ListaMeses').hide();
        loader('block');
        $('#expirado').hide();

        $.HSCore.components.HSGoTo.init('.js-go-to');
        $(".footer-base").addClass("space-top-3");
        $(".footer-base").addClass("d-sm-block");
        $(".footer-base").show();

        function loader(type) {
            vm.loaderStyle = {
                display: type
            };
            if (type == 'block') $('#loader').show();
            else $('#loader').hide();
        }
        /*vm.aceptarpagar = function(){
            if(vm.formapago != ''){
                $('#modalforma').modal('hide');   
                var codigores = $('#numreserva').val();
                var params = {
                    total : vm.summary.total.toFixed(2),
                    coin : vm.summary.moneda,
                    modepayment : vm.formapago,
                    numreserva : codigores
                };
                vm.total = vm.summary.total.toFixed(2);
                PaymentFactory.datoswebpay(params).then(function(response){
                    if(response.status==200)
                        {   
                            $('#diviframe').show();
                            var url = response.data;
                            vm.urlwebpay = url;
                            $('#iframe').html("").append($("<iframe id='pagowp' name='master' src="+vm.urlwebpay+" style='width:100%; height: 100%; border:0; margin-top: -47px;'></iframe>"));
                            $('#iframevisa').html("").append($("<iframe id='pagowpvisa' name='visa' src="+vm.urlwebpay+" style='width:100%; height: 100%; border:0; margin-top: -47px;'></iframe>"));
                            // $('#iframevisa').html("").append($("<iframe id='pagowpvisa' src="+url+" style='width:100%; height: 100%; border:0;'></iframe>"));
                        }
                }).catch(function(er){
                    console.log(er);
                });             
            }else{
                $('#oppagar').show();
            }
        }*/
        /*   $('#ListaBancos').change(function(){
               vm.bancoselected = $(this).val();
               
               if(vm.bancoselected !=''){
                   $('#ListaMeses').show();
                   $('.radio').prop("checked", false);
                   vm.showformpagos = false;
               }else{
                   $('#diviframe').hide();
                   $('#ListaMeses').hide();
                   vm.showformpagos = false;
               }

               // switch (vm.bancoselected){
               //     case '':
               //         break;
               //     case 'Banamex':
               //         amex();
               //         break;
               //     default:
               //     webpay();
               //         break;
               // }
           });*/
        function amex() {
            vm.showFormAmex = true;
        }

        function webpay() {
            var codigores = vm.cart.reference;

            var total = vm.summary.total;

            if (vm.cart.currency !== 'MXN') {
                total = vm.summary.total * vm.cart.exchangeRate;
            }

            var params = {
                total: total,
                coin: 'MXN',//vm.summary.moneda,
                modepayment: vm.formapago,
                numreserva: codigores
            };
            vm.showformpagos = true;
            PaymentFactory.datoswebpay(params).then(function(response) {
                if (response.status == 200) {
                    var url = response.data;
                    vm.urlwebpay = url;
                    setTimeout(function() {
                        $('#iframe').html("").append($("<iframe id='pagowp' src='" + vm.urlwebpay + "' style='width:103%; border:0; margin-top: -80px; margin-left: -10px;'></iframe>"));
                    }, 5);
                    vm.showformpagos = false;
                    $('#diviframe').show();
                }
            }).catch(function(er) {
                console.log(er);
            });
        }
        $('.espanol').on('click', function() {});
        Cart.getPaymentCart(angular.element('#tokenId').val())
            .then(function (response) {
                vm.reference = response.data.cart.reference;
                vm.cart =           response.data.cart;
                vm.summary = {};
                vm.summary.total = vm.cart.total + vm.cart.taxes;
                vm.summary.moneda = vm.cart.currency;
                vm.hotelData = vm.cart.items[0];
                vm.webpay =         response.data.webpay;
                vm.timeExpired =    response.data.timeExpired;
                vm.cart.discount_price = parseFloat((( vm.cart.total / 1.19) * 100) / (100 - vm.cart.items[0].discount)) 
                vm.cart.loaded =    true;

                timeService.init({
                    callback: function (conteo) {
                        vm.counter = (conteo < 0) ? 0: conteo;
                    },
                    end: function () {
                        HotelFactory.cancelOperation()
                            .then(function () {
                                // console.info('exit');
                            })
                            .catch(function (err) {
                                // console.error(err.data);
                            }); 
                        $('#expirado').show();
                        
                        vm.timeExpired = true;
                    },
                    initialCounting: response.data.timeElapsed
                });

                document.getElementById('loaderStylereservacion').style.display = 'none';
            })
            .catch(function (response) {

            });

        /* $scope.$on('cartLoaded', function(event, args) {
            document.getElementById('loaderStylereservacion').style.display = 'none';
            angular.forEach(args.content, function(item) {
                if (item.type == 'hotel') {
                    vm.hotelData = item;
                    timeService.init({
                        callback: function(conteo) {
                            vm.counter = conteo;
                        },
                        end: function() {
                            HotelFactory.cancelOperation().then(function() {
                                console.info('exit');
                            }).catch(function(err) {
                                console.error(err.data);
                            });
                            $('#expirado').show();
                            vm.timeExpired = true;
                        },
                        initialCounting: vm.hotelData.check
                    });
                    console.log(vm.hotelData);               
                }
                if (item.type == 'auto') {
                    vm.hotelData = item;
                    timeService.init({
                        callback: function(conteo) {
                            vm.counter = conteo;
                        },
                        end: function() {
                            HotelFactory.cancelOperation().then(function() {
                                console.info('exit');
                            }).catch(function(err) {
                                console.error(err.data);
                            });
                            $('#expirado').show();
                            vm.timeExpired = true;
                        },
                        initialCounting: vm.hotelData.check
                    });
                    console.log(vm.hotelData);               
                }
            });
        }); */
        // Cart.init();
        // PaymentFactory.isValid().then(function(response){
        //     console.log(response);
        //     vm.isValidPaymentAdvance = response.data.isValid;
        // });
        // PaymentFactory.getTotal().then(function(response) {
        //     vm.tarjetas = response.data.tarjetas;
        //     // vm.summary = response.data;
        //     // vm.summary.total = parseFloat(vm.summary.total.toFixed(2));
        //     $timeout(loader('none'), 2000);
        //     PaymentFactory.getPercents().then(function(response) {
        //         vm.percentages = response.data.percentages;
        //         vm.advancePaymentIsValid = response.data.isValid;
        //         vm.limitDate = response.data.limitDate;
        //         if (vm.percentages.length > 0) {
        //             vm.percentages = response.data.percentages;
        //             angular.forEach(response.data.percentages, function(percentage, index) {
        //                 percentage.total = parseFloat(((vm.summary.total / 100) * percentage.percentage).toFixed(2));
        //             });
        //         }
        //         // console.log(vm.percentages, "vm.percentages");
        //     });
        // });

        vm.radioHasChanged = function() {
            if (vm.cmeses == "C") {
                vm.totalpagar = vm.summary.total;
            } else if (vm.cmeses == "3M") {
                vm.totalpagar = vm.totaltres * 3;
            } else if (vm.cmeses == "6M") {
                vm.totalpagar = vm.totalseis * 6;
            } else if (vm.cmeses == "9M") {
                vm.totalpagar = vm.totalnueve * 9;
            } else if (vm.cmeses == "12M") {
                vm.totalpagar = vm.totaldoce * 12;
            }
            vm.formapago = vm.cmeses;
            webpay();
        };

        vm.tarjetaseleccionada = function() {
            $('#iframe').html("");
            $('.radio').prop("checked", false);
            vm.tresmeses = false;
            vm.seismeses = false;
            vm.nuevemeses = false;
            vm.docemeses = false;

            var total = vm.summary.total;

            if (vm.cart.currency !== 'MXN') {
                total = vm.summary.total * vm.cart.exchangeRate;
            }

            //$('#ListaMeses').hide();
            for ($i = 0; $i < vm.tarjetas.length; $i++) {
                if (vm.tarjetas[$i].banco == vm.tarjetaselect) {
                    if (vm.tarjetas[$i].montomdocem < total && vm.tarjetas[$i].docemeses == 1) {
                        vm.docemeses = true;
                        vm.totaldoce = (vm.summary.total + ((vm.summary.total * vm.tarjetas[$i].porcetajedocem) / 100)) / 12
                    }
                    if (vm.tarjetas[$i].montomnuevem < total && vm.tarjetas[$i].nuevemeses == 1) {
                        vm.nuevemeses = true;
                        vm.totalnueve = (vm.summary.total + ((vm.summary.total * vm.tarjetas[$i].porcetajenuevem) / 100)) / 9
                    }
                    if (vm.tarjetas[$i].montomseism < total && vm.tarjetas[$i].seismeses == 1) {
                        vm.seismeses = true;
                        vm.totalseis = (vm.summary.total + ((vm.summary.total * vm.tarjetas[$i].porcetajeseism) / 100)) / 6
                    }
                    if (vm.tarjetas[$i].montomtresm < total && vm.tarjetas[$i].tresmeses == 1) {
                        vm.tresmeses = true;
                        vm.totaltres = (vm.summary.total + ((vm.summary.total * vm.tarjetas[$i].porcetajetresm) / 100)) / 3
                    }
                }
                $('#ListaMeses').show();
            }
        }
        vm.master = function() {
            $('#diviframe').show();
            $('#diviframevisa').hide();
            $('#form-datos-pago-res').hide();
        }
        vm.visa = function() {
            $('#diviframe').hide();
            $('#diviframevisa').show();
            $('#form-datos-pago-res').hide();
        }
        vm.amex = function() {
            $('#form-datos-pago-res').show();
            $('#diviframe').hide();
            $('#diviframevisa').hide();
        }
        PaymentFactory.getValidatedCoupon().then(function(response) {
            if (response.status == 200) {
                vm.coupon = {
                    amount: response.data.cantidad
                };
                vm.couponAdded = true;
            }
        }).catch(function(err) {});
        vm.setCoupon = function() {
            PaymentFactory.validaCupon(vm.cupon).then(function(response) {
                var cupon = response.data;
                swal(cupon.messageTitle, cupon.message);
                if (cupon.valido) {
                    vm.couponAdded = true;
                    vm.coupon = {
                        amount: cupon.cantidad
                    }
                }
            }).catch(function(err) {});
        }
        vm.onSelectPercent = function(item) {
            vm.selectedPercent = item;
        }
        vm.onlyAPercent = function() {
            vm.completePayment = false;
            vm.cupon = null;
            vm.couponAdded = false;
            PaymentFactory.quitCupon().then(function(response) {});
        }
        vm.reset = function() {
            vm.selectedPercent = null;
            vm.currentPercent = null;
            vm.completePayment = true;
        }
        vm.storeTotal = function() {
            var params;
            if (angular.isDefined(vm.selectedPercent)) {
                params.selectedPercent = vm.selectedPercent;
                params.moneda = vm.totals.moneda;
            }
            PaymentFactory.storePayment(params).then(function(response) {
                // console.log(response);
            });
        }
    }
})();